import React, { useState, useEffect } from 'react';
import LocalStorageUtil from '@utils/storage/localStorage';
import classnames from 'classnames/bind';
import styles from './bottom.module.scss';
import { MILLISECONDS_PER_DAY } from '@domain/constant/Time';
const cx = classnames.bind(styles);

const DchampsBottomBanner = () => {
  const [bannerVisible, setBannerVisible] = useState(false);

  const handleDelete = () => {
    setBannerVisible(false);
  };

  const handleDeleteOneDay = () => {
    LocalStorageUtil.setItem('dchampsBannerDeleteOneDay', 'true', {
      expires: new Date(Date.now() + MILLISECONDS_PER_DAY),
    });
    handleDelete();
  };

  useEffect(() => {
    const dchampsBannerDeleteOneDay = LocalStorageUtil.getItem('dchampsBannerDeleteOneDay');

    if (!dchampsBannerDeleteOneDay) {
      setBannerVisible(true);
    }
  }, []);

  if (!bannerVisible) return null;

  return (
    <div className={cx('dchampsBannerArea')}>
      <a className={cx('banner')}>
        <span className={cx('hidden')}>
          이번 주에 참가 완료하면 배달의민족 1만원 쿠폰 드려요!선착순 200명 한정 (9월 10일 23시 59분까지 디챔스 참가
          완료자)
        </span>
      </a>

      <a className={cx('btnDeleteOneDay')} role="button" onClick={handleDeleteOneDay}>
        <span className={cx('hidden')}>오늘은 그만 보기</span>
      </a>

      <a className={cx('btnDelete')} role="button" onClick={handleDelete}>
        <span className={cx('hidden')}>닫기</span>
      </a>
    </div>
  );
};

export default DchampsBottomBanner;
